import { useEffect } from "react";
import JSEncrypt from 'jsencrypt';
import CryptoJS from 'crypto-js';
import { checkStid } from "@/services/api";
import Cookies from "js-cookie";
import api_domain_config from "@/config/config";
import { connect } from "react-redux";
import actions from "@/redux/action";
import { useNavigate } from "react-router-dom";

// 客户端跳转中转页
const TransferPage = (props) => {
  const navigate = useNavigate();
  useEffect(() => {
  /**
   * 获取当前地址栏上携带的stid(从客户端跳转过来)
   */
   var currentUrl = window.location.href;
   //使用正则表达式从URL中提取参数部分（?之后的部分）
   var urlParameters = currentUrl?.split('?')[1];
   if(urlParameters) {
     // 将参数部分分割成一个键值对的数组
     var parameterPairs = urlParameters.split('&');
     // 创建一个对象来存储参数键值对
     var parameters = {};
     // 遍历键值对数组，将参数存储在对象中
     for (var i = 0; i < parameterPairs.length; i++) {
       var pair = parameterPairs[i].split('=');
       var key = decodeURIComponent(pair[0]); // 解码参数名
      //  var value = decodeURIComponent(pair[1]) // 解码参数值
       var value = decodeURIComponent(pair[1].toString().replace(/%20/g, '+'));
       parameters[key] = value;
     }
     var paramValue = parameters['stid'];
     var curToken = parameters['token'];
    // 存在stid
     if (paramValue) {
      var timestamp = Math.round(new Date().getTime() / 1000); // 获取当前时间戳（十位数）
      var dataToEncrypt = paramValue + ';' + timestamp;
      var pubKey = '-----BEGIN PUBLIC KEY-----MIICIDANBgkqhkiG9w0BAQEFAAOCAg0AMIICCAKCAf8xHWgJJrcFhcNbT/qqdNcg7Gv61FU16hGNPojEX/D+VYtWnOZWp8jWEPbXtzhNKpXv3Zfkdnew+qdnXXpZFc53YAVG+7+fQchhEcH9vsoLUWZOsqkT56LzrrAl72g8x++pQJhZTskUQa7wRVJxrXCct5rI/xTsoY8izfKdAuTvZwAs8/R3o2zBra4FVbR0xPVVUHgdXPpX9piJyDaz5s8C/FcAyByFHz5mDH6uznm/r0STp9IYYtSOK3odn1ZthCb36t9BNeawPWmXk8eb0VqoG71o0qHT9WzbINrHlUYbNxOxWJuJi591dDljPdVP5UX3tn1I2S5RtLNOcpgD/yFWtK0NzjyxAfDXwyFV0TUleN0nxD8kRmo+V422NyMFC8lzU1o/nggT031cstoeRBh8Txfmze+HrS1HhRDxrfc0r4ShS91qpV3+t+dzpYeVwNx1kRG1lxf3tFHPMjlgcXbHBvbiY4wbI73fPiHop4kNsuJx0fgnz5LDHfjbLCgGBwQQGQxdMqx8yTU1KuHz8SCCw1Kz324DhyDNOqr6gCQBvYl8afFZorV6wZ92Ip5unDAtSpqhCBbEnjanNz7ez4nsEkZO5PinuK4/iej6gpiuPKRoZniDdTNyrmuJKtLIraUGdZODWGqC1V/wO/6Iw4SkgbGAjybYSknQ5Lx92rNVAgMBAAE=-----END PUBLIC KEY-----'
      var encryptor = new JSEncrypt();
      encryptor.setPublicKey(pubKey); // 使用服务器的公钥进行加密
    
      var encryptedData = encryptor.encrypt(dataToEncrypt);
    
      // 将 encryptedData 发送给后端
      checkStid({ 'stid': encryptedData }).then((res) => {
        if (res.code === 200) {
          var encryptedBase64 = res.data.access_token;
          // 密钥和初始化向量
          var key = CryptoJS.enc.Utf8.parse('7eZqt#H.pcXH3M7z');
          var iv = CryptoJS.enc.Utf8.parse('ehl=#SIMNf9Gl:pS');
          // 将 Base64 编码的数据解码
          var encryptedData = CryptoJS.enc.Base64.parse(encryptedBase64);
          // 解密
          var decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encryptedData },
            key,
            { iv: iv, mode: CryptoJS.mode.CBC }
          );
          // 将字节数组转换为字符串
          var decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
          console.log("Decrypted Text:", (decryptedText));
          props.onAuthorizationChange(decryptedText);
          //将当前authorization存在顶级域名cookies底下
          Cookies.set("authorization", decryptedText, { expires: 30, domain: api_domain_config.DOMAIN });
          //重定向当前的路由
          navigate('/personal-center/product-list', {replace: true})
        }
      }).catch((error) => {
        console.log(error)
      })
     }
     //兼容老用户, 是否存在token
     if (curToken) {
        /**
         * 将当前地址栏上的token解密后，截取掉前12个字符，才是真正的token
         */
        const curUserToken = window.atob(curToken).slice(0, -12);
        /**
         * 更新当前store中的数据
         */
        props.onAuthorizationChange(curUserToken);
        //将当前authorization存在顶级域名cookies底下
        Cookies.set("authorization", curUserToken, { expires: 30, domain: api_domain_config.DOMAIN });
        //重定向当前的路由
        navigate('/personal-center/product-list', {replace: true})
     }
   }
  },[])
  return (
    <div style={{minHeight: 750}}></div>
  );
};

const mapStateToPropos = state => ({
  authorization: state.account.authorization,
});
const mapDispatchToProps = dispatch => ({
  onAuthorizationChange: authorization => dispatch(actions.onAuthorizationChange(authorization)),
});


export default connect(mapStateToPropos, mapDispatchToProps)(TransferPage);;
